import { Controller } from "@hotwired/stimulus"

// Auto-opens the Feature Update drawer once for a signed-in web user. The server only
// renders this (and the drawer) for an eligible, unseen user, and opening the drawer
// lazy-loads its content from #show, which records the view, so it won't render again
// afterward. A DOM-only opened marker guards against re-opening on Turbo cache
// restoration without surviving a fresh render after `feature_updates:reset`.

export default class extends Controller {
  static values = { triggerId: String }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    if (this.alreadyOpened) return

    // The drawer sits further down the page, so its own controller may not have
    // connected yet. One frame is enough for Stimulus to finish connecting every
    // controller in the document.
    this.openFrame = requestAnimationFrame(() => this.open())
  }

  disconnect() {
    cancelAnimationFrame(this.openFrame)
  }

  open() {
    const drawer = document.querySelector(`[data-trigger-id="${this.triggerIdValue}"]`)
    if (!drawer) return

    drawer.dispatchEvent(new Event("bottom-drawer:open"))
    if (drawer.open) this.markOpened()
  }

  get alreadyOpened() {
    return this.element.dataset.opened === "true"
  }

  markOpened() {
    this.element.dataset.opened = "true"
  }
}
